module.exports = {
  Characters: {
    PluginName: "Characters",
    background_color: "Background color",
    border_color: "Border color",
    border_size: "Border Size",
    border_style: "Border Style",
    box_style: "Box style",
    opacity: "Opacity",
    padding: "Padding",
    pos: "Position",
    radius: "Radius",
    source: "Source",
    scale: "Zoom",
    message_mark_xy:
      "You've chosen an incorrect value. You must introduce two numbers separated by a comma. E.g. 4.56,90.76",
    hyperlink: "Directs to",
    link_placeholder: "http://...",
    allowDeformed: "Do not adjust to container",
  },
};
